import React from 'react';
import styled from 'styled-components';

type FormGroupComponentProps = {
  children: React.ReactNode
  className?: string
  onSubmit: React.FormEventHandler
  onKeyDown?: React.KeyboardEventHandler
}

const FormGroupStyle = styled.form`
  background: #fafafa;
  border-radius: 25px;
  margin: 0 10px;
  padding: 25px 20px;

  @media (max-width: 767px) {
    padding: 25px 10px;
  }
`;

const FormGroup: React.FC<FormGroupComponentProps> = ({ children, className, onSubmit, onKeyDown }) => {
  return (
    <FormGroupStyle className={className} onSubmit={onSubmit} onKeyDown={onKeyDown}>
      { children }
    </FormGroupStyle>
  );
};

export default FormGroup;
